
import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import App from "../components/appStartkit";
import InternLinks from "../components/internlinks";
import Product3 from "../components/Product3";
import data from '../data/products3.json'
import { Breadcrumb } from "../components/globals/breadcrumb";


const IndexPage = () => (
   <Layout2>
      <Breadcrumb category={["nyheter", "nyheter"]} page={["Vita tänder med väteperoxid", "vitare-tander-hemma"]} />
      <SEO title="Vita tänder med väteperoxid" description="Hur man får vitare tänder hemma" keywords={[`Tips`, `Vita tänder`, `Metoder`, `Hemma`, `2021`]} />
      <section className="section-metoder">
         <main>

            <img src="../tandvard.jpg" style={{ width: "100%" }} alt="Vita tänder med väteperoxid" />
            <h1 class="welcome">Vita tänder med väteperoxid</h1>
            <p class="text-center">Väteperoxid är ett naturligt blekmedel som också dödar bakterier i munnen.
               Många kommersiella tandblekningshjälpmedel innehåller väteperoxid, men i en mycket högre
               koncentration än du kommer att använda om du gör det själv.
            </p><p class="text-center">
               Tyvärr har inga studier undersökt effekterna av att skölja eller borsta med enbart väteperoxid,
               men flera studier har analyserat kommersiella tandkrämer innehållande peroxid, tex <a href="https://adtr.co/VBePbO" target="_blank" rel="noopener noreferrer">Spotlight Oral Care</a> hos Lyko.
            </p><p class="text-center">
               En studie visade att en tandkräm innehållande natron och 1% väteperoxid ledde till betydligt vitare tänder.
               En annan studie visade att borstning med en kommersiell tandkräm innehållande natron och peroxid två gånger per dag ledde till 62% vitare tänder på 6 veckor.
            </p><p class="text-center">
               <b>OBS! Det finns dock frågor angående hur hälsosamt det är med väteperoxid.</b>
            </p><p class="text-center">
               Medan kraftigt utspädda koncentrationer verkar säkra kan starka koncentrationer eller
               överanvändning orsaka tandköttsirritation och tandkänslighet.
               Det finns också en oro för att höga doser kan orsaka cancer, men detta har inte bevisats.
            </p><p class="text-center">
               Ett sätt att använda väteperoxid är som munvatten innan du borstar tänderna.
               Se till att du använder en 1,5% eller 3% lösning för att undvika biverkningar.
               Den vanligaste koncentrationen av väteperoxid i apoteket är en 3% lösning.
               Du kan enkelt späda ut denna koncentration till 1,5% genom att blanda lika
               delar peroxid och vatten.
            </p>
            <p class="text-center">

            </p>
         </main>
         <section className="section-cards">
            <main className="card__ai">
               <h2 class="card-rubrik">Startkit</h2>
               <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
               <App />
            </main>
         </section>


         <main>
            <h3 class="welcome">Vad får tänderna att se gula ut?</h3>
            <p class="text-center">
               Flera faktorer gör att tänderna blir tråkiga och förlorar sin ljusa, vita gnista.
               Vissa livsmedel kan fläcka din emalj, som är det yttersta lagret av dina tänder. Dessutom kan plackuppbyggnad på dina tänder få dem att se gula ut.
            </p><p class="text-center">
               Denna typ av missfärgning kan vanligtvis behandlas med vanliga rengörings- och blekmedel.
               Ibland ser tänderna emellertid gula ut eftersom den hårda emaljen har eroderat och avslöjar dentinet under. Dentin är en naturligt gul, benig vävnad som ligger under emaljen.
            </p>
            <h3 class="welcome">1. Gurgla med olja</h3>
            <p class="text-center">
               Att gurgla munnen med olja är ett traditionellt indiskt recept som är avsett att förbättra
               munhygienen och ta bort gifter från kroppen.
            </p><p class="text-center">
               Det går ut på att man gurglar oljan i munnen för att ta bort bakterier som kan bli plack och få dina
               tänder att se gula ut.
            </p><p class="text-center">
               Traditionellt använde indianer solros- eller sesamolja för detta, men vilken olja som helst fungerar.
            </p><p class="text-center">
               Kokosolja är ett populärt val eftersom den har en behaglig smak och erbjuder många hälsofördelar.
               Kokosolja innehåller också mycket laurinsyra, vilket är känt för sin förmåga att minska inflammation
               och döda bakterier.
            </p><p class="text-center">
               Streptococcus mutans är en av de typerna av bakterier i munnen som orsakar plack och
               tandköttsinflammation. En studie visade att daglig gurgling med sesamolja signifikant minskade
               Streptococcus mutans i saliv på så lite som en vecka
            </p><p class="text-center">
               Tyvärr har inga vetenskapliga studier visat att gurgling gör tänderna vitare och tar bort missfärgning.
               Det är dock en säkert sätt och värt ett försök.
               Många människor hävdar att deras tänder är vitare och ljusare efter oljegurgling.
            </p><p class="text-center">
               För att gurglaolja, lägg 1 msk kokosnötolja i munnen och gurgla/skölj oljan genom tänderna och i munnen.
               Kokosolja är fast vid rumstemperatur, så du kan behöva vänta några sekunder tills den smälter.
               Fortsätt att gurgla i 15–20 minuter.
            </p><p class="text-center">
               Var noga med att spotta kokosnötoljan i en toalett eller papperskorg,
               eftersom den kan återgå till fast form en gång i avloppsrören och orsaka igensättning.
            </p><p class="text-center">
               Till skillnad från många andra tandblekningsmetoder utsätter inte kokosnötoljan dina
               tänder för syra eller andra ingredienser som eroderar emaljen. Det betyder att det är säkert
               att göra detta dagligen.</p>
         </main>
      </section>
      <div className="section-cards">
         <main className="card__ai">
            <h2 class="card-rubrik">Bästa tandkrämerna</h2>
            <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
            <Product3 produkt={data.tandkram} />
         </main>
      </div>
      <section className="section-metoder">
         <main>
            <h3 class="welcome">2. Borsta med bakpulver</h3>
            <p class="text-center">Bakpulver har naturliga blekningsegenskaper, vilket också är varför det är en populär
               ingrediens i vanlig tandkräm. Det är ett milt slipmedel som kan hjälpa till att skrubba
               bort ytfläckar på tänderna. Dessutom förhindrar bakpulver bakterier från att växa.
            </p><p class="text-center">
               Detta är inte ett hjälpmedel som gör dina tänder vitare över natten, men du bör märka en
               skillnad i utseendet på dina tänder över tiden.
            </p><p class="text-center">
               En studie visade att tandkräm innehållande syra var mycket effektivare för att ta bort
               gula fläckar från tänderna än vanliga tandkrämer utan syra. Ju högre koncentration bakpulver,
               desto större blir effekten.
            </p><p class="text-center">
               Vidare visade en genomgång av fem studier att tandkräm som innehåller bakpulver
               avlägsnade plack från tänderna mer effektivt än tandpasta utan bakpulver.
            </p><p class="text-center">
               För att använda detta, blanda 1 tsk bakpulver med 2 teskedar vatten och borsta tänderna med pastan.
               Du kan göra detta några gånger i veckan.
            </p><p class="text-center">
               Det finns dock ett litet problem om du använder för mycket. Problemet är att bakpulvret även
               slipar ner själva emaljen. Emaljen skyddar tänderna från sötsaker, repor, slag och ger tänderna
               glans. </p>

         </main>
      </section>


      <section className="section-metoder">
         <main>
            <h3 class="welcome">3. Ät frukt och grönsaker</h3>
            <p class="text-center">En diet med mycket frukt och grönsaker kan vara bra för både din kropp och dina tänder.
               Krispiga, råa frukter och grönsaker kan hjälpa till att gnugga bort plack när du tuggar.
            </p><p class="text-center">
               <b>Jordgubbar</b> </p>
            <p class="text-center">
               Att bleka tänderna med en jordgubbs- och bakpulverblandning är ett naturligt botemedel som har
               blivit populärt av kändisar.
            </p><p class="text-center">
               Förespråkare för denna metod hävdar att äppelsyra som finns i jordgubbar kommer att ta bort
               missfärgning på tänderna, medan bakpulver kommer att tona bort fläckar.
            </p><p class="text-center">
               Detta tips har dock inte helt bevisats av vetenskapen.
            </p><p class="text-center">
               Medan jordgubbar kan hjälpa till att exfoliera tänderna och få dem att se vitare ut,
               kommer de troligen inte att tränga igenom fläckarna på tänderna.
            </p><p class="text-center">
               En nyligen genomförd studie visade att en jordgubbs- och bakpulverblandning gav
               mycket liten färgförändring i tänderna jämfört med tandblekningshjälpmedel.
               Om du bestämmer dig för att prova den här metoden, begränsa användningen till några
               gånger per vecka. Trots studier som visade att en jordgubbs- och bakpulvermetod hade en
               minimal effekt på tandemaljen, kan överdriven användning orsaka skador.
            </p><p class="text-center">
               <b>Ananas</b>
            </p><p class="text-center">Vissa hävdar att ananas kan bleka tänderna.
               En studie visade att en tandkräm innehållande bromelain, ett enzym som finns i ananas,
               var signifikant effektivare för att ta bort tandfläckar än en vanlig tandkräm.
            </p><p class="text-center">
               Det finns dock inga bevis för att äta ananas ger samma effekt.
            </p>
         </main>
      </section>
      <section className="section-cards card-height">
         <main>
            <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
            <InternLinks />
         </main>
      </section>

      <section className="section-metoder">
         <main>
            <h3 class="welcome">4. Förhindra tandfläckar innan de inträffar</h3>
            <p class="text-center">
               Dina tänder blir naturligt gula när du åldras men vissa saker kan hjälpa till att
               förhindra fläckar på tänderna.
            </p><p class="text-center">
               <b>Begränsa färgning av mat och dryck</b>
            </p><p class="text-center">
               Kaffe, rött vin, läsk och mörka bär är ökända för att färga tänderna.
               Det betyder inte att du måste undvika dem helt, men du bör begränsa den tid
               dessa ämnen är i kontakt med dina tänder.
            </p><p class="text-center">
               Om möjligt, drick drycker som är kända för att fläcka tänderna ur ett sugrör för
               att förhindra direkt kontakt med dina tänder.
            </p><p class="text-center">
               Dessutom borsta dina tänder efter att ha konsumerat dessa livsmedel eller drycker
               för att begränsa deras effekter på tändernas färg.
            </p><p class="text-center">
               Undvik att röka och tugga tobak, eftersom båda kan orsaka missfärgning av tänderna.
            </p><p class="text-center"><b>Begränsa ditt sockerintag</b>
            </p><p class="text-center">
               Om du vill ha vitare tänder, skära ner på ditt sockerintag .
               En diet med hög sockerhalt stöder tillväxten av Streptococcus mutans,
               den primära typen av bakterier som orsakar plack och tandköttsinflammation.
               När du konsumerar en sockerhaltig mat bör du borsta tänderna strax efter.
            </p><p class="text-center"><b>Få mycket kalcium i din kost</b>
            </p><p class="text-center">Viss missfärgning av tänderna orsakas av emaljutmattning och
               exponering av dentinet under, som är gult. Därför kommer allt du gör för att stärka
               emaljens tänder att hålla dina tänder pärlvit.
            </p><p class="text-center">Kalciumrika livsmedel, såsom mjölk, ost och broccoli, kan
               hjälpa till att skydda dina tänder från emaljerosion.
            </p>
            <h3 class="welcome">5. Underskatta inte värdet av borstning och tandtråd</h3>
            <p class="text-center">Medan viss missfärgning av tänderna naturligt kommer med
               åldern är det till stor del ett resultat av plackuppbyggnad. Regelbunden borstning och
               tandtråd kan hjälpa dina tänder att hålla vita genom att minska bakterier i munnen och
               förhindra ansamling av plack.
            </p><p class="text-center">
               Tandkräm gnuggar försiktigt ut fläckar på tänderna och tandtråd tar bort bakterier
               som leder till plack.</p><p class="text-center">
               Regelbundna tandrengöringar kan också hjälpa dina tänder att hålla sig rena och vita.
            </p></main>
      </section>

   </Layout2>
)

export default IndexPage
